// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';

import styles from './styles';
import { Paragraph } from '../../../../components';

class ItemDescription extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    likeNew: PropTypes.string,
    veryGood: PropTypes.string,
    good: PropTypes.string,
    rejectReasons: PropTypes.array,
    isBooks: PropTypes.bool,
    booksParagraph1: PropTypes.string,
    booksParagraph2: PropTypes.string,
    booksParagraph3: PropTypes.string,
    isDVD: PropTypes.bool,
    rejectAlsoEndText: PropTypes.string,
    rejectAlsoReasons: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    title: 'title',
    description: 'description',
    likeNew: null,
    veryGood: null,
    good: null,
    rejectReasons: ['it bad'],
    isBooks: false,
    isDVD: false,
    booksParagraph1: 'booksParagraph1',
    booksParagraph2: 'booksParagraph2',
    booksParagraph3: 'booksParagraph3',
    rejectAlsoEndText: null,
    rejectAlsoReasons: [],
  };

  render() {
    const {
      classes,
      title,
      description,
      likeNew,
      veryGood,
      good,
      rejectReasons,
      isBooks,
      isDVD,
      booksParagraph1,
      booksParagraph2,
      booksParagraph3,
      rejectAlsoEndText,
      rejectAlsoReasons,
    } = this.props;

    const rejectBefore = 'We will ';
    const rejectBeforeAlso = 'We also will ';
    let rejectAfter = isBooks ? ' books that have:' : ` ${title} where:`;
    if (isDVD) {
      rejectAfter = ' DVD\'s where:';
    }

    return (
      <div className={classes.mainContainer}>
        <span className={classes.title}>{title}</span>
        {isBooks && (
          <div>
            <Paragraph text={booksParagraph1} />
            <h4 className={classes.booksSubTitle}>Quality Explained</h4>
            <Paragraph text={booksParagraph2} />
            <Paragraph text={booksParagraph3} />
          </div>
        )}
        {!isBooks && <span className={classes.description}>{description}</span>}
        {likeNew && (
          <div className={classes.conditionContainer}>
            <span className={classes.blueText}>Like New: </span>
            <span>{likeNew}</span>
          </div>)}
        {veryGood && (
          <div className={classes.conditionContainer}>
            <span className={classes.blueText}>Very Good: </span>
            <span>{veryGood}</span>
          </div>)}
        {good && (
          <div className={classes.conditionContainer}>
            <span className={classes.blueText}>Good: </span>
            <span>{good}</span>
          </div>)}
        <div className={classes.rejectContainer}>
          <div className={classes.rejectTitleContainer}>
            <span className={classes.blueText}>{rejectBefore}</span>
            <span className={classes.rejectText}>REJECT</span>
            <span className={classes.blueText}>{rejectAfter}</span>
          </div>
          <ul>{rejectReasons.map(el => <li key={uuidv4()}>{el}</li>)}</ul>
        </div>
        {rejectAlsoEndText && (
          <div className={classes.rejectContainer}>
            <div className={classes.rejectTitleContainer}>
              <span className={classes.blueText}>{rejectBeforeAlso}</span>
              <span className={classes.rejectText}>REJECT</span>
              <span className={classes.blueText}>{rejectAlsoEndText}</span>
            </div>
            <ul>{rejectAlsoReasons.map(el => <li key={uuidv4()}>{el}</li>)}</ul>
          </div>)}
      </div>
    );
  }
}

export default withStyles(styles)(ItemDescription);
